import {TestType, TestTypeStorage} from './types';

export const mappedTestTypeForStore: Record<TestType, TestTypeStorage> = {
	[TestType.None]: TestTypeStorage.None,
	[TestType.Rubric]: TestTypeStorage.Rubric,
	[TestType.Score]: TestTypeStorage.Score,
	[TestType.YN]: TestTypeStorage.YN,
};
